export default class KitMedia {
  constructor() {
    function chiffreOpen() {
      document.querySelectorAll(".arrowDown").forEach((button) => {
        button.addEventListener("click", () => {
          const chiffreContent = document.querySelector(".chiffres-content");
          button.classList.toggle("active");
          if (button.classList.contains("active")) {
            chiffreContent.style.maxHeight =
              chiffreContent.scrollHeight + 20 + "px";
            chiffreContent.style.padding = "10px 0";
          } else {
            chiffreContent.style.maxHeight = 0;
            chiffreContent.style.padding = "0 0";
          }
        });
      });
    }
    chiffreOpen();

    function openModal() {
      const idKitmedia = document.querySelector(".kit-media");
      const chiffreContent = idKitmedia.querySelector(".chiffres-content");
      const chiffreBoxs = chiffreContent.querySelectorAll(".chiffres-box");
      const modals = idKitmedia.querySelectorAll(".modal");
      chiffreBoxs.forEach((box) => {
        box.addEventListener("click", function () {
          modals.forEach((modal) => {
            if (this.dataset.modal === modal.id) {
              modal.style.display = "block";
              modal.classList.add("in");

              var spanClose = modal.querySelector(".close");

              spanClose.onclick = function () {
                modal.style.display = "none";
              };
              window.onclick = function (e) {
                if (e.target == modal) {
                  modal.style.display = "none";
                }
              };
            } else {
              modal.style.display = "none";
            }
          });
        });
      });
    }
    openModal();
  }
}
